'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = null;

var PurchaseMotionsByLocation = function PurchaseMotionsByLocation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.PURCHASE_MOTIONS_BY_LOCATION_RECEIVED:
      return payload;

    default:
      return state;
  }
};

exports.default = PurchaseMotionsByLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/PurchaseMotionsByLocation.js
// module id = 390
// module chunks = 3 4 5